import React, { Component } from "react";
import { message, Popover, Input, Button, Popconfirm, Form, Table } from "antd";
import { auth } from '../firebase';

import "../App.css";
import { Link } from 'react-router-dom'
// We import our firestore module
import { db, storr } from '../firebase/firebase';


const { TextArea } = Input;
//=================editable==========================
const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
//=================editable==========================

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'areaa') {
      return <TextArea autosize />;
    } else
      return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [{
                      required: true,
                      message: `Please Input ${title}!`,
                    }],
                    initialValue: record[dataIndex],
                  })(this.getInput())}
                </FormItem>
              ) : restProps.children}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}

const content = (
  <div>
    <p>Click me to manage units!</p>
  </div>
);

export class ProjectList extends Component {
  constructor(props) {
    super(props);

    // Set the default state of our application
    this.state = {
      pendingMedia: "",
      data: [],
      ta: null,
      pa: null,
      aa: null,
      show: false,
      html: "<p>write some text here</p>",
      editorState: null,
    };

    this.columns = [
      {
        title: 'Project Name',
        dataIndex: 'name',
        width: '18%',
        editable: false,
        render: (text, record) => {
          const editable = this.isEditing(record);
          return (
            <div>
              <Popover content={content}>
                <Button size='large' type="primary" ><Link to={'/dashboard/projects/' + this.state.data[record.key].id + '/' + this.state.data[record.key].name}>{this.state.data[record.key].name}</Link></Button>
              </Popover>
            </div>
          );
        },
      },
      {
        title: 'Description',
        dataIndex: 'title',
        width: '20%',
        inputType: 'areaa',
        editable: true,
      },
      {
        title: '',
        dataIndex: 'values',
        width: '10%',
        editable: false,
        render: (text, record) => {
          const editable = this.isEditing(record);
          return (
            <div>
              <Button type="primary" ghost><Link to={'/dashboard/projects/' + this.state.data[record.key].id + '/' + this.state.data[record.key].name+ "/packages"}>Packages</Link></Button>
            </div>
          );
        },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '15%',
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <Button
                        
                        onClick={() => this.save(form, record.key)}
                        style={{ marginRight: 8 }}
                      >
                        Save
                      </Button>
                    )}
                  </EditableContext.Consumer>
                  <Button
                  type='primary'
                    onClick={() => this.cancel(record.key)}
                  >
                    Cancel
                      </Button>

                </span>
              ) : (
                  <div>
                    <Button
                    type='primary'
                      onClick={() => this.edit(record.key)}
                    >
                      Edit
                </Button>
                  </div>
                )}
            </div>
          );
        },
      },
    ];



    this.pullLa = this.pullLa.bind(this);

    this.pullLa();

    this.addProject = this.addProject.bind(this);

    this.pullFromDB();

    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({email: user.email})
      }
    });
  }
  pullFromDB() {
    // We listen for live changes to our events collection in Firebase
    db.collection("project").onSnapshot(snapshot => {
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });
      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }


      // Anytime the state of our database changes, we update state
      this.setState({ data });

    })
  }

 

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }




  async addProject() {
    await db.collection("project").add({
      name: this.makeid(5),
      title: 'title',
    });
  }









  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit(key) {
    this.setState({ editingKey: key });
    this.state.show = true
  }



  sect2(key, value) {
    // console.log("promotion man... " + JSON.stringify(value))
    // this.state.data[key].promotion = value;
  }


  save(form, key) {
    message.loading('Saving...')
    this.state.show = false
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });

        this.state.ta = newData[index].title

        // alert("OLD DATA: " + JSON.stringify(this.state.data[index]))
        // alert("the pa ta xa...: " + this.state.pa + this.state.ta + this.state.xa + this.state.ya + this.state.sa)

        // console.log("update! record.key: " + id + "todo id: " + this.state.data[id].id)
        db
          .collection("project")
          .doc(this.state.data[index].id).update({
            title: this.state.ta
          })
          .then(() => {
            message.destroy()
            message.success("Document successfully updated!");
            this.setState({ data: newData, editingKey: '' });
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            message.destroy()
            message.error("Error updating document: " + error.message);
          });


      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: '' });
      }
    });
  }

  cancel = () => {
    this.setState({ editingKey: '' });
    this.state.show = false
  };



  pullLa() {
    // We listen for live changes to our events collection in Firebase
    db.collection("project").onSnapshot(snapshot => {
      let mada = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        mada.push(todo);
      });

      //assign primary key
      for (var i = 0; i < mada.length; i++) {
        mada[i].key = i;
      }
      // Anytime the state of our database changes, we update state
      this.setState({ mada });
    })
  }






  render() {
    // const { editorState } = this.state;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'title' ? 'areaa' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });
    return (
      <div>
        <h1 className="block">Projects</h1>
        {this.state.email == 'cc@cc.cc' ? <Button onClick={() => this.addProject()}>Add</Button> : <div />}
        
        
        <Table
          components={components}
          bordered
          pagination={{ pageSize: 15 }}
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
        />
      </div>

    )
  }


}
export default ProjectList;



// WEBPACK FOOTER //
// ./src/views/projectlist.js